import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./editor.scss";

export type EditorId = string;
export type EditorKey = string;

export interface EditorProps {
  id: EditorId; // 언어 코드 or 고유 ID
  defaultValue?: string; // 수정 시 초기값
  readonly?: boolean;
  onChange?: (id: EditorId, value: string) => void;
}

const BaseEditor: React.FC<EditorProps> = ({
  id,
  defaultValue = "",
  readonly = false,
  onChange,
}) => {
  const [value, setValue] = useState<string>("");
  const isInitialized = useRef<boolean>(false);

  /**
   * defaultValue는 최초 1회만 적용
   * (등록/수정 혼합 시 필수)
   */
  useEffect(() => {
    if (!isInitialized.current) {
      setValue(defaultValue);
      isInitialized.current = true;
    }

    return () => {
      isInitialized.current = false;
    };
  }, [defaultValue]);

  /**
   * ReactQuill onChange handler
   * 사용자 입력(source === "user")만 처리
   */
  const handleChange = (
    content: string,
    delta: unknown,
    source: "user" | "api" | "silent"
  ): void => {
    if (source !== "user") return;
    setValue(content);
    // setEditorHtml(content);

    onChange?.(id, content);
  };

  return (
    <ReactQuill
      id={id}
      theme="snow"
      value={value}
      className="w-full flex-1 h-auto"
      onChange={handleChange}
      readOnly={readonly}
      modules={{
        toolbar: toolbarOptions,
      }}
    />
  );
};

export default BaseEditor;

const toolbarOptions = [
  [{ header: "1" }, { header: "2" }, { font: [] }],
  [{ size: ["small", "medium", "large", "huge"] }], // font-size 선택 옵션
  ["code-block"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["bold", "italic", "underline"],
  [{ align: [] }],
  ["link"],
  ["image"],
  ["blockquote"],
  [{ color: [] }, { background: [] }], // 글자 색상, 배경 색상
];
